var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('img',{staticClass:"img-avatar",attrs:{"src":require("../assets/img/7.jpg")}})]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aeca568","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSettingsDropdown.vue
// module id = null
// module chunks = 